<div class="notification-menu">
  <div
    class="notification-menu__header flex justify-between items-center p-4 border-bottom"
  >
    <strong>
      <span>{{ "labels.NOTIFICATIONS" | translate }}</span>
    </strong>
    <a
      class="p-button p-button-outlined"
      [routerLink]="['/', 'notifications']"
      (click)="notificationRedirect.emit(true)"
      >{{ "labels.ALL_NOTIFICATIONS" | translate }}</a
    >
  </div>

  <ng-container
    [ngTemplateOutlet]="
      !loading && !notifications.length ? emptyList : notificationMenu
    "
  ></ng-container>
</div>

<ng-template #notificationMenu>
  <ul
    class="notification-menu__list"
    appInfiniteScroll
    [triggerBefore]="100"
    (scrolled)="onScroll()"
  >
    <li
      data-testId="notification-item"
      class="layout-topbar-action-item notification-item cursor-pointer"
      *ngFor="let notification of notifications; let first = first"
      [ngClass]="{
        'new-notification': !notification?.readAt,
      }"
      (click)="onNotificationClicked(notification)"
      (keyup.enter)="onNotificationClicked(notification)"
    >
      <figure
        class="notification-item__image !inline-flex !justify-center !items-center"
      >
        <i
          *ngIf="notification?.icon?.name; else defaultImg"
          class="{{ notification.icon?.name | getIconCssClass }}"
        ></i>
        <ng-template #defaultImg>
          <img
            src="/assets/images/avatar.jpg"
            [attr.alt]="notification?.title | propertyTranslator"
          />
        </ng-template>
        <figcaption hidden class="hidden">
          {{ notification?.title | propertyTranslator }}
        </figcaption>
      </figure>
      <div class="notification-item-container">
        <strong class="notification-item__title block">{{
          notification?.title | propertyTranslator
        }}</strong>
        <p class="notification-item__text">
          {{ notification?.content | propertyTranslator }}
        </p>
        <span class="notification-item__date text-muted">
          {{ notification.creationInfo.doneAt | fromNow: dateFormat }}
        </span>
      </div>
    </li>
    <ng-container
      *ngIf="loading"
      [ngTemplateOutlet]="!!notifications.length ? pageLoad : firstLoad"
    >
    </ng-container>
  </ul>
</ng-template>

<ng-template #firstLoad>
  <li class="" data-testid="loading-item">
    <ng-container [ngTemplateOutlet]="notificationLoader"></ng-container>
  </li>
  <li class="" data-testid="loading-item">
    <ng-container [ngTemplateOutlet]="notificationLoader"></ng-container>
  </li>
  <li class="" data-testid="loading-item">
    <ng-container [ngTemplateOutlet]="notificationLoader"></ng-container>
  </li>
</ng-template>

<ng-template #pageLoad>
  <li class="" data-testid="loading-item">
    <ng-container [ngTemplateOutlet]="notificationLoader"></ng-container>
  </li>
</ng-template>

<ng-template #notificationLoader>
  <div class="notification-loader">
    <div class="flex notification-loader__header p-4">
      <div>
        <p-skeleton width="54px" height="54px" shape="circle"></p-skeleton>
      </div>
      <div class="pt-2 px-4 notification-loader__description">
        <p-skeleton width="100px" height="10px"></p-skeleton>
        <p-skeleton class="mt-4 block" width="100%" height="10px"></p-skeleton>
        <p-skeleton class="mt-2 block" width="100%" height="10px"></p-skeleton>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #emptyList>
  <div
    class="flex justify-center items-center empty-list"
    data-testId="empty-msg"
  >
    {{ "NOTIFICATION.EMPTY" | translate }}!
  </div>
</ng-template>
